import type { CostDashboardFiltersPayload, CostDashboardFiltersResponse, CostDashboardResponse, CostPayload, ResourcegroupLevelCostDataPayload, ResourcegroupLevelCostDataResponse, SubscriptionForCostResponse } from "@/features/cost/types/summary.types";
import type { CostAnalyticsPayload, CostAnalyticsResponse } from "@/features/cost/types/analytics.types";
import type { GenerateReportRequest, GenerateReportResponse, ParentCustomerRequest, RawCostReportRequest, RawCostUsageResponse, reportTypeObj, ServiceFilterRequest, ServiceFilterResponse, StampCustomerMappingResponse, StampCustomerRequest } from "@/features/cost/types/cost-report.types";
import type { InsightDto, WeeklyCustomerCostRequest, WeeklyCostReportResponse, WeeklyCostRequest } from "@/features/cost/types/weekly-cost-report.types";
import api from "@/services/apiClient";
export const costService = {
  GetCostDashboardSummary: (
    payload: CostPayload,
    options?: { signal?: AbortSignal },
  ): Promise<CostDashboardResponse> =>
    api
      .post("Cost/summary", payload, { signal: options?.signal })
      .then((res) => res.data),
  ///--------------------------------------------- Cost Analytics Summary -------------------------------------------
  GetCostAnalyticsSummary: (
    payload: CostAnalyticsPayload,
    options?: { signal?: AbortSignal },
  ): Promise<CostAnalyticsResponse> =>
    api
      .post("Cost/cost-analytics", payload, { signal: options?.signal })
      .then((res) => res.data),
  ///--------------------------------------------- Customer and Rg filters -------------------------------------------
  GetDashboardFiltersForCost: (
    payload: CostDashboardFiltersPayload,
    options?: { signal?: AbortSignal },
  ): Promise<CostDashboardFiltersResponse> =>
    api
      .post("Cost/GetCostDashboardFilters", payload, {
        signal: options?.signal,
      })
      .then((res) => res.data),
  ///--------------------------------------------- Customer and Rg filters -------------------------------------------
  GetResourceGroupLevelCost: (
    payload: ResourcegroupLevelCostDataPayload,
  ): Promise<ResourcegroupLevelCostDataResponse> =>
    api
      .post("Cost/GetCostByResourceGroupLevel", payload)
      .then((res) => res.data),
  ///--------------------------------------------- Cost Dashboard Subscription Details -------------------------------------------
  GetSubscriptionDetailsForCost: (): Promise<SubscriptionForCostResponse[]> =>
    api.get("Cost/GetCostSubscriptions").then((res) => res.data),

  ///--------------------------------------------- fetch parent Customers -------------------------------------------
  GetParentCustomersBySubscriptions: (
    payload: ParentCustomerRequest,
  ): Promise<string[]> =>
    api
      .post("Cost/GetParentCustomersBySubscription", payload)
      .then((res) => res.data),
  ///--------------------------------------------- Customer Cost Dashboard export Details -------------------------------------------
  GenerateCostReportByCustomer: (
    payload: GenerateReportRequest,
  ): Promise<GenerateReportResponse> =>
    api.post("Cost/GenerateReport", payload).then((res) => res.data),
  ///--------------------------------------------- Cost Dashboard GetRecipients Details -------------------------------------------
  GetCostRecipients: (): Promise<string[]> =>
    api.get("Cost/GetCostRecipients").then((res) => res.data),
  ///--------------------------------------------- Cost Dashboard GetRecportTypes Details -------------------------------------------
  GetCostReportTypes: (): Promise<reportTypeObj[]> =>
    api.get("Cost/report-types").then((res) => res.data),
  ///--------------------------------------------- Service Filters -------------------------------------------
  GetServiceFiltersByCategory: (
    payload: ServiceFilterRequest,
    options?: { signal?: AbortSignal },
  ): Promise<ServiceFilterResponse> =>
    api
      .post("Cost/GetServiceFiltersByCategory", payload, {
        signal: options?.signal,
      })
      .then((res) => res.data),

  ///--------------------------------------------- Stamp Customer Mapping -------------------------------------------
  GetStampCustomerMappings: (
    payload: StampCustomerRequest,
  ): Promise<StampCustomerMappingResponse> =>
    api.post("Cost/GetStampCustomerMappings", payload).then((res) => res.data),

  ///--------------------------------------------- Raw Cost Usage -------------------------------------------
  GetRawCostUsageByCategory: (
    payload: RawCostReportRequest,
    options?: { signal?: AbortSignal },
  ): Promise<RawCostUsageResponse> =>
    api
      .post("Cost/GetRawCostUsageByCategory", payload, {
        signal: options?.signal,
      })
      .then((res) => res.data),

  ///--------------------------------------------- Weekly cost report -------------------------------------------
  fetchWeeklyCostReport: (
    payload: WeeklyCostRequest,
    options?: { signal?: AbortSignal },
  ): Promise<WeeklyCostReportResponse> =>
    api
      .post("Cost/weekly-cost-report", payload, { signal: options?.signal })
      .then((res) => res.data),

  ///--------------------------------------------- Weekly customer cost report -------------------------------------------
  ///--------------------------------------------- Weekly customer cost report -------------------------------------------
  fetchWeeklyCustomerReport: (
    payload: WeeklyCustomerCostRequest,
    options?: { signal?: AbortSignal },
  ): Promise<WeeklyCostReportResponse> =>
    api
      .post("Cost/weekly-customer-report", payload, {
        signal: options?.signal,
      })
      .then((res) => {
        // API returns just the insights array, wrap it in the expected response format
        const insightsArray: InsightDto[] = Array.isArray(res.data) ? res.data : res.data?.insights || [];
        return {
          insights: insightsArray,
          kpiSummary: { currentWeekCost: 0, previousWeekCost: 0, changePercent: 0, avgDailyCost: 0, prevAvgDailyCost: 0, avgDailyChangePercent: 0 },
          trend: [],
          services: [],
          customers: [],
        } as WeeklyCostReportResponse;
      }),
};
